<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-print text-primary"></i> {{$t('repair.titleadd')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent>
                    <div class="row" v-if="isAdmin()">
                        <div class="col-md-12">
                            <h4 class="text-primary">{{$t('repair.asf')}}</h4>
                            <multiselect
                                v-model="asf_value"
                                :options="asfs"
                                :custom-label="asfLabel"
                                :placeholder="$t('repair.text.selectone')"
                                label="name"
                                track-by="id"
                                @open="getAsfs"
                                @input="selectAsfs"
                            ></multiselect>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="text-primary">{{$t('repair.customer')}}</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-10">
                            <label for="warranty">{{$t('repair.findcustomer')}}</label>
                            <multiselect
                                id="customer"
                                v-model="customer_value"
                                :options="customer"
                                :custom-label="customersLabel"
                                :placeholder="$t('repair.text.selectone')"
                                label="name"
                                track-by="id"
                                :hide-selected="true"
                                @input="selectCustomer"
                            ></multiselect>
                        </div>
                        <div class="col-md-2">
                            <label for class="d-block">&nbsp;</label>
                            <p-button
                                class="btn btn-primary btn-sm mb-3"
                                v-b-modal.AddCustomer
                            >{{$t('repair.button.addnewcustomer')}}</p-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="text-primary">{{$t('repair.repairinformation')}}</h4>
                            <fg-input
                                type="text"
                                :label="$t('repair.asfserviceid')"
                                v-model="form.service_number"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <h4 class="text-primary">{{$t('repair.productinformation')}}</h4>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <fg-input type="text" :label="$t('repair.modelname')" v-model="form.model_name"></fg-input>
                        </div>
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('repair.serialnumber')"
                                v-model="form.serial_number"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label for="warranty">{{$t('repair.warranty')}}</label>
                                <select class="form-control" id="warranty" v-model="form.warranty">
                                    <option value>{{$t('repair.text.select')}}</option>
                                    <option value="In Warranty">{{$t('status.in_warranty')}}</option>
                                    <option value="Out of Warranty">{{$t('status.out_warranty')}}</option>
                                    <option value="Warranty Loss">{{$t('status.warranty_loss')}}</option>
                                    <option value="Partial Warranty">{{$t('status.partial_warranty')}}</option>
                                    <option value="Special Case">{{$t('status.special_case')}}</option>
                                </select>
                            </div>
                        </div>
                        <div v-if="!inWarranty" class="col-md-6">
                            <div class="form-group">
                                <label for>{{$t('repair.estimationapproved')}}</label>
                                <select class="form-control" v-model="form.estimate_approved">
                                    <option value>{{$t('repair.text.select')}}</option>
                                    <option value="1">{{$t('text.yes')}}</option>
                                    <option value="0">{{$t('text.no')}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <slot v-if="inWarranty">
                        <div class="row">
                            <div class="col-md-4">
                                <fg-input
                                    type="text"
                                    :label="$t('repair.invoicenumber')"
                                    v-model="form.invoice_number"
                                ></fg-input>
                            </div>
                            <div class="col-md-4">
                              <label for="datepicker-invoice_date">{{ $t("repair.invoicedate") }}</label>
                              <b-form-datepicker
                                id="datepicker-invoice_date"
                                v-model="form.invoice_date"
                                class="m-0 p-0"
                                size="sm"
                                :max="max_date"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                :dark=true
                                :placeholder="$t('dashboard.select_date')"
                              ></b-form-datepicker>
                            </div>
                            <div class="col-md-4">
                                <label for>{{$t('repair.uploadinvoicefile')}}</label>
                                <b-form-file
                                    accept="image/png, image/jpeg, image/jpg, application/pdf"
                                    v-model="form.invoice_file"
                                    :placeholder="$t('repair.text.chooseafile')"
                                ></b-form-file>
                                <small
                                    class="text-muted"
                                >{{$t('repair.text.allowedfiletypesinvoice')}}</small>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{$t('repair.accessories')}}</label>
                                    <slot v-for="(accessory, index) in accessories">
                                        <div class="form-check" v-if="accessory.category=='product'">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                :value="accessory.id"
                                                v-model="form.accessories"
                                                :id="'accessory'+accessory.id"
                                            />
                                            <label
                                                :for="'accessory'+accessory.id"
                                            >{{ accessory.name }}</label>
                                        </div>
                                    </slot>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for>{{$t('repair.receivedby')}}</label>
                                    <select class="form-control" v-model="form.collect_by">
                                        <option value>{{$t('repair.text.select')}}</option>
                                        <option value="Walk-in">{{$t('repair.option.walkin')}}</option>
                                        <option value="By mail">{{$t('repair.option.bymail')}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label for>{{$t('repair.productcondition')}}</label>
                                    <select class="form-control" v-model="form.product_condition">
                                        <option value>{{$t('repair.text.select')}}</option>
                                        <option value="No-damage">{{$t('repair.option.nodamage')}}</option>
                                        <option value="Some damage">{{$t('repair.option.somedamage')}}</option>
                                        <option value="Dirty">{{$t('repair.option.dirty')}}</option>
                                        <option value="Ink Leakage">{{$t('repair.option.inkleakage')}}</option>
                                        <option value="Damaged">{{$t('repair.option.damaged')}}</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <label for>{{$t('repair.productimages')}}</label>
                                <b-form-file
                                    accept="image/png, image/jpeg, image/jpg"
                                    v-model="product_images"
                                    :placeholder="$t('repair.text.chooseafile')"
                                    @change="onFileChange"
                                ></b-form-file>
                                <small
                                    class="text-muted"
                                >{{$t('repair.text.allowedfiletypesimage')}}</small>
                            </div>
                        </div>
                        <slot v-if="images_preview">
                            <div class="preview row">
                                <slot v-for="(image, index) in images_preview">
                                    <div class="col-1">
                                        <img :src="image" alt class="img-fluid img-thumbnail" />
                                        <a @click="removeImage(index)">
                                            <i class="fas fa-times"></i>
                                        </a>
                                    </div>
                                </slot>
                            </div>
                        </slot>

                        <div class="row">
                            <div class="col-md-12">
                                <h4 class="text-primary">{{$t('repair.issuereporting')}}</h4>
                            </div>
                        </div>
                        <!-- <div class="row">
              <div class="col-md-12">
                <label>Issue Categories</label>
              </div>
            </div>
            <div class="row">
              <slot v-for="(column, index) in issues">
                <div class="col-md-6">
                  <slot v-for="(issue, index) in column">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        :value="issue.id"
                        v-model="form.issues"
                        :id="'issue'+issue.id"
                      >
                      <label :for="'issue'+issue.id">{{ issue.name }}</label>
                    </div>
                  </slot>
                </div>
              </slot>
                        </div>-->
                        <!-- 
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="hidden"
                      value="1"
                      id="error_code_reported_customer"
                      v-model="error_code_reported_customer"
                    >
                    <label class="form-check-label" for="error_code_reported_customer">
                      <b>Error Code Reported by Customer</b>
                    </label>
                  </div>
                </div>
              </div>
            </div>
                        -->
                        <div class="row">
                            <div class="col-md-12">
                                <label class="typo__label">{{$t('repair.customererrors')}}</label>
                                <multiselect
                                    v-model="value"
                                    :options="customer_issues"
                                    :multiple="true"
                                    :placeholder="$t('repair.text.selectone')"
                                    label="name"
                                    track-by="id"
                                    :hide-selected="true"
                                    @input="selectCustomerIssue"
                                ></multiselect>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="issue_reported_customer">{{$t('repair.errorsdescription')}}</label>
                                    <textarea
                                        class="form-control"
                                        v-model="form.issue_reported_customer"
                                    ></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <fg-input
                                    type="text"
                                    :label="$t('repair.printerinitializationstate')"
                                    v-model="form.initialization_date"
                                ></fg-input>
                            </div>
                            <div class="col-md-6">
                                <fg-input
                                    type="text"
                                    :label="$t('repair.printedpagescount')"
                                    v-model="form.page_count"
                                ></fg-input>
                            </div>
                            <!-- <div class="col-md-2">
                <div class="form-group">
                  <fg-input
                    type="text"
                    label="Error Code"
                    v-model="form.error_code_reported_customer"
                  ></fg-input>
                </div>
                            </div>-->
                        </div>
                        <!-- <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="issue_reported_customer">Issue Reported Technician</label>
                  <textarea class="form-control" v-model="form.issue_reported_technician"></textarea>
                </div>
              </div>
                        </div>-->
                    </slot>
                    <slot>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="technical_analysis">{{$t('repair.technicalanalysis')}}</label>
                                    <textarea
                                        class="form-control"
                                        v-model="form.technical_analysis"
                                    ></textarea>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>{{$t('repair.cartridges')}}</label>
                                    <slot v-for="(accessory, index) in accessories">
                                        <div class="form-check" v-if="accessory.category=='issue'">
                                            <input
                                                class="form-check-input"
                                                type="checkbox"
                                                :value="accessory.id"
                                                v-model="form.accessories"
                                                :id="'accessory'+accessory.id"
                                            />
                                            <label
                                                :for="'accessory'+accessory.id"
                                            >{{ accessory.name }}</label>
                                        </div>
                                    </slot>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="service_executed">{{$t('repair.serviceexecuted')}}</label>
                                    <textarea class="form-control" v-model="form.service_executed"></textarea>
                                </div>
                            </div>
                        </div>
                    </slot>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="form-group">
                                <label for="notes">{{$t('repair.notes')}}</label>
                                <textarea class="form-control" v-model="form.notes"></textarea>
                            </div>
                        </div>
                    </div>
                    <div class="text-left">                      
                        <p-button type="primary" :disabled='isDisabled' @click.native.prevent="save">{{$t('repair.button.save')}}</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
        <b-modal id="AddCustomer" size="lg" hide-footer :title="$t('customer.addnewcustomer')">
            <add-customer></add-customer>
        </b-modal>
    </card>
</template>
<script>
import { mapState } from "vuex";
import chunk from "lodash/chunk";
import Multiselect from "vue-multiselect";
import AddCustomer from "@/pages/repairs/AddCustomer.vue";

export default {
  data() {
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const maxDate = new Date(today);
    return {
      disabled: false,
      value: "",
      asf_value: "",
      error_code_reported_customer: 0,
      images_preview: [],
      product_images: [],
      customer_value: "",
      max_date: maxDate,
      form: {
        asf_id: this.$store.getters["auth/getCurrentAsf"],
        city: "",
        state: "",
        country: "",
        repair_id: "",
        model_name: "",
        serial_number: "",
        warranty: "",
        invoice_number: "",
        invoice_date: "",
        invoice_file: "",
        initialization_date: "",
        page_count: "",
        accessories: [],
        collect_by: "",
        product_condition: "",
        product_images: [],
        issues: [],
        customer_issues: [],
        issue_reported_customer: "",
        issue_reported_technician: "",
        technical_analysis: "",
        service_number: "",
        service_executed: "",
        notes: ""
      }
    };
  },
  computed: {
    ...mapState("repairs", {
      repair: "repair"
    }),
    ...mapState("asfs", {
      asfs: "all"
    }),
    ...mapState("customers", {
      customers: "all"
    }),
    customer() {
      return this.$store.getters["customers/getAll"];
    },
    accessories: {
      get() {
        return this.$store.getters["accessories/getAll"];
      },
      set(value) {}
    },
    customer_issues: {
      get() {
        return this.$store.getters["issues/getCustomerIssues"];
      },
      set() {}
    },
    isDisabled: function(){
    	return this.disabled;
    },
    issues: {
      get() {
        return chunk(
          this.$store.getters["issues/getAll"],
          this.$store.getters["issues/getAll"].length / 2
        );
      },
      set() {}
    },
    inWarranty() {
      let warr = ["In Warranty", "Partial Warranty", "Special Case"];
      return warr.includes(this.form.warranty);
    }
  },
  methods: {
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.form.product_images.push(file);
      this.images_preview.push(URL.createObjectURL(file));
      e.target.value = "";
    },
    removeImage(index) {
      this.images_preview.splice(index, 1);
      this.form.product_images.splice(index, 1);
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs");
    },
    selectAsfs(option) {
      this.form.asf_id = option.id;
    },
    customersLabel({ name, document }) {
      return `${name} — ${document}`;
    },
    selectCustomerIssue(option) {
      this.form.customer_issues = [];
      option.forEach(item => {
        this.form.customer_issues.push(item.id);
      });
    },
    selectCustomer(option) {
      this.form.customer_id = option.id;
    },
    save() {
      // console.log("save");
      // console.log(this.form);
      this.disabled = true;

      if (!this.form.asf_id) {
        this.$notify({
          type: "danger",
          horizontalAlign: "center",
          message: this.$t('repair.message.selectasfassociate')
        });
      }
      this.$store
        .dispatch("repairs/add", this.form)
        .then(response => {
          this.$router.push({ name: "repairs" });
          this.$notify({
            type: "success",
            message: this.$t('repair.message.successadd')
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response && error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });

          this.disabled = false;
        });        
    }
  },
  created() {
    this.$store.dispatch("customers/getAll");
    this.$store.dispatch("accessories/getAll");
    this.$store.dispatch("issues/getAll");
    this.$store.dispatch("issues/getCustomerIssues");
  },
  console: () => console,
  components: {
    Multiselect,
    AddCustomer
  }
};
</script>
<style>
</style>
